import { render, staticRenderFns } from "./IconSvgWrench.vue?vue&type=template&id=b885aa84&scoped=true&"
import script from "./IconSvgWrench.vue?vue&type=script&lang=js&"
export * from "./IconSvgWrench.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b885aa84",
  null
  
)

export default component.exports